import { Badge, Group } from "@mantine/core"

import { getProviderColor } from "@costory/shared/utils/provider"

import {
  AwsSvgComponent,
  GcpSvgComponent,
  AzureSvgComponent,
  DatadogSvgComponent,
  ConfluentSvgComponent,
  AivenSvgComponent,
} from "@costory/front/components/DatasourceImages"

interface ProviderPillProps {
  providers: string[] | undefined
}

const PROVIDER_ICON_MAP: Record<
  string,
  (props: React.SVGProps<SVGSVGElement>) => JSX.Element
> = {
  AWS: AwsSvgComponent,
  GCP: GcpSvgComponent,
  Azure: AzureSvgComponent,
  Datadog: DatadogSvgComponent,
  Confluent: ConfluentSvgComponent,
  Aiven: AivenSvgComponent,
}

export function ProviderPills({ providers }: ProviderPillProps) {
  if (!providers?.length) {
    return null
  }

  return (
    <Group gap="xs" style={{ flexWrap: "wrap" }}>
      {providers.map((provider) => {
        const IconComponent = PROVIDER_ICON_MAP[provider]
        const color = getProviderColor(provider)

        return (
          <Badge
            key={provider}
            variant="outline"
            color={color}
            leftSection={
              IconComponent ? (
                <IconComponent width={12} height={12} />
              ) : undefined
            }
            size="sm"
          >
            {provider}
          </Badge>
        )
      })}
    </Group>
  )
}
